const config = {
  ENABLE_REGISTRATION: true,
};

export default config;
